<template>
	<label class="form-label">
		<span>Choose Template (optional)</span>
	</label>
	<Multiselect
		v-model="templateName"
		:options="options"
		@change="onTemplateChange"
		class="multiselect-blue"
	>
		<template v-slot:singlelabel="{ value }">
			<div class="multiselect-single-label">
				<span class="option__label">{{ value.name }}</span>
			</div>
		</template>
		<template v-slot:option="{ option }">
			<div>
				<span class="option__label">{{ option.name }}</span>
				<span class="text-muted"
					><strong>{{ option.description }}</strong></span
				>
			</div>
		</template>
	</Multiselect>

	<div v-if="parameters.length" class="my-3">
		<label for="basic-url" class="form-label">Fill in the following parameters(optional)
		</label>
		<form-fields :fields="parametersFields" v-model="parameterValue" :inlineField="true" />
	</div>
</template>

<script>
import Multiselect from "@vueform/multiselect";
import { mapActions } from "vuex";
import FormFields from "./FormFields.vue";
export default {
	components: { Multiselect, FormFields },
	data() {
		return {
			templateName: null,
			currentTemplate: null,
			options: [],
			parameters: [],
			parameterValue: {}
		};
	},
	props: {
		jobTemplates: {
			type: Array,
			default: () => [],
		}
	},
	watch: {
		jobTemplates(newVal) {
			let self = this;
			this.options = [];
			newVal.map((template) => {
				return self.options.push({
					name: template.name,
					value: template.name,
					description: template.description,
				});
			});
		},
		parameterValue: {
			handler(newVal) {
				this.$emit("onParameterChanged", newVal);
			},
			deep: true
		}
	},
	computed: {
		parametersFields() {
			let fields = []
			this.parameters.forEach((value, index) => {
				delete value.value;
				fields.push({
					name: value.name,
					label: value.name,
					type: value.type === "string" ? "text" : value.type,
					editable: !value.read_only,
					placeholder: value.description
				})
			})
			return fields
		}
	},
	methods: {
		...mapActions({
			readTemplateJob: "amdp/readTemplateJob"
		}),
		async onTemplateChange(templateName) {
			if (templateName) {
				this.$emit("onSelectTemplate", true);
				this.currentTemplate = await this.fetchJobTemplate(templateName);
				this.$emit("setCurrentTemplate", this.currentTemplate);
				this.parameters = this.currentTemplate?.parameters || [];
				this.$emit("onSelectTemplate", false);
			} else {
				this.currentTemplate = null;
				this.$emit("setCurrentTemplate", this.currentTemplate);
				this.parameters = [];
			}
		},
		async fetchJobTemplate(templateName) {
			let response = {};
			try {
				response = await this.readTemplateJob(templateName);
				response = await response.data;
			} catch (error) {
				if (error.response.data.error) this.error = error.response.data.error;
				else this.error = error.message;
				return;
			}
			return response
		}
	},
	emits: ["onParameterChanged", "setCurrentTemplate", "onSelectTemplate"],
};
</script>

<style scoped>	
	.option__label {
		display: block;
	}
</style>
